import { Controller } from "@hotwired/stimulus"
import { getCredential, postJSON, supportsWebAuthn } from "../webauthn"

// Drives passkey sign-in on the login page: fetch a challenge, let the
// authenticator assert a passkey, post it back, then follow the redirect.
export default class extends Controller {
  static targets = ["button", "error"]
  static values = { challengeUrl: String, verifyUrl: String }

  connect() {
    if (!supportsWebAuthn() && this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.title = "This browser doesn't support passkeys"
    }
  }

  async authenticate(event) {
    event.preventDefault()
    this.clearError()
    this.setBusy(true)

    try {
      const options = await postJSON(this.challengeUrlValue)
      if (options.error) throw new Error(options.error)

      const credential = await getCredential(options)
      const result = await postJSON(this.verifyUrlValue, { credential })

      if (result.redirect) {
        window.location.href = result.redirect
      } else {
        throw new Error(result.error || "Passkey sign-in failed.")
      }
    } catch (error) {
      if (error.name === "NotAllowedError" || error.name === "AbortError") {
        this.clearError() // user dismissed the prompt — stay silent
      } else {
        this.showError(error.message || "Passkey sign-in failed.")
      }
      this.setBusy(false)
    }
  }

  setBusy(busy) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = busy
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  clearError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
